module.exports = __webpack_public_path__ + "img/dispatch.1f458670.svg";